import {resources, scopes} from '../../permissions/dictionary';
import {paths} from '../../dictionaries/urls';
import {filterByPermissions} from './helpers';
import {wtsOut, wtsOutProcesos} from './wtsMenuBuilder';

const servicesFTR = [{
  'name': 'Buscar FTR/RSR',
  'path': paths.FormsSearch,
  'resource': resources.FormsSearch,
  'scopes': [scopes.See],
  'icon': 'ftrSearch',
}, {
  'name': 'Ingresados',
  'path': paths.EnteredAnswersList,
  'resource': resources.FormsManage,
  'scopes': [scopes.Edit],
  'icon': 'ftrEntered',
}, {
  'name': 'Nuevo FTR/RSR',
  'path': paths.FormsList,
  'resource': resources.FormsManage,
  'scopes': [scopes.Create],
  'icon': 'ftrEntered',
}];

const servicesSKR = [{
  'name': 'Buscar SKR',
  'path': paths.FormsSkrSearch,
  'resource': resources.FormsSkrSearch,
  'scopes': [scopes.See],
  'icon': 'ftrSearch',
}, {
  'name': 'Nuevo SKR',
  'path': '/formulario-skr/nuevo',
  'resource': resources.FormsSkrManage,
  'scopes': [scopes.Create],
  'icon': 'ftrEntered',
}];

const serviceEnterProcess = [{
  'name': 'Mantenimiento de Formularios',
  'path': paths.MaintainFormsServices,
  'resource': resources.MaintainFormsServices,
  'scopes': [scopes.See],
  'icon': 'ftrSearch',
},
{
  'name': 'Mantenimiento de Campañas',
  'path': paths.CampaignList,
  'resource': resources.MaintainCampaign,
  'scopes': [scopes.See, scopes.Edit, scopes.Create],
  'icon': 'ftrSearch',
}];

const serviceExitQueryProcess = [{
  'name': 'Campañas y Chasis',
  'path': paths.CampaignAndChassisQuery,
  'resource': resources.CampaignAndChassisServices,
  'scopes': [scopes.See],
  'icon': 'dateManagement',
},
{
  'name': 'Reporte de Garantias en Campañas',
  'path': paths.WarrantyCampaignsReport,
  'resource': resources.WarrantyCampaignsReport,
  'scopes': [scopes.See],
  'icon': 'dateManagement',
},
{
  'name': 'Boletines',
  'path': paths.BulletinQuery,
  'resource': resources.BulletinQuery,
  'scopes': [scopes.See],
  'icon': 'dateManagement',
},
];

const serviceBulletins = [
  {
    'name': 'Ingreso Boletin de Servicio',
    'path': paths.BulletinService,
    'resource': resources.BulletinService,
    'scopes': [scopes.Create],
    'icon': 'ftrEntered',
  },
  {
    'name': 'Ingreso Boletin TMC',
    'path': paths.BulletinTMC,
    'resource': resources.BulletinTMC,
    'scopes': [scopes.Create],
    'icon': 'ftrEntered',
  },
];

const getServicesProcessOptions = (permissions) => {
  const options = [
    {
      'name': 'Formularios',
      'options': filterByPermissions(permissions, servicesFTR),
    },
    {
      'name': 'SKR',
      'options': filterByPermissions(permissions, servicesSKR),
    },
    {
      'name': 'Boletines',
      'options': filterByPermissions(permissions, serviceBulletins),
    },
    {
      'name': 'WTS',
      'options': filterByPermissions(permissions, wtsOutProcesos),
    },
  ];

  return options.filter((item) => item.options.length);
};

const getEnterProcessOptions = (permissions) => {
  const options = [
    {
      'name': 'Mantenimiento',
      'options': filterByPermissions(permissions, serviceEnterProcess),
    },
    {
      'name': 'WTS',
      'options': filterByPermissions(permissions, wtsOut),
    },
  ];
  return options.filter((item) => item.options.length);
};

const getExitProcessOptions = (permissions) => {
  const options = [{
    'name': 'Consultas',
    'options': filterByPermissions(permissions, serviceExitQueryProcess),
  }];
  return options.filter((item) => item.options.length);
};

export const getServicesOptions = (permissions) => {
  const options = [
    {
      'name': 'Entrada',
      'options': getEnterProcessOptions(permissions),
    },
    {
      'name': 'Proceso',
      'options': getServicesProcessOptions(permissions),
    },
    {
      'name': 'Salida',
      'options': getExitProcessOptions(permissions),
    },
  ];

  return options.filter((item) => item.options.length);
};

export const servicesOptions = [
  ...servicesFTR,
  ...servicesFTR,
  ...serviceEnterProcess,
  ...serviceExitQueryProcess,
  ...wtsOut,
];
